import React from 'react';
import Section from 'design-system/Section';
import { useAppSelector } from 'store/hooks';
import CreditScoreEnhancedFactorCard from './CreditScoreEnhancedFactorCard';
import { selectCreditScoreNextBestAction, selectIsCreditScoreAvailable, } from '../selectors';
const CreditScoreNextBestActionCard = () => {
    const shouldShow = useAppSelector(selectIsCreditScoreAvailable);
    const nextBestAction = useAppSelector(selectCreditScoreNextBestAction);
    if (!shouldShow || !nextBestAction)
        return null;
    return (<Section title="Credit boosting action">
      <CreditScoreEnhancedFactorCard title={nextBestAction.displayTitle || ''} subTitle={nextBestAction.message} highestImpact smallMargin/>
    </Section>);
};
export default CreditScoreNextBestActionCard;
